/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  bordered: Boolean,
  colon: Boolean,
  column: {
    type: Number,
    "default": 2
  },
  contentStyle: {
    type: Object
  },
  itemLayout: {
    type: String,
    "default": "horizontal",
    validator: function validator(val) {
      if (!val) return true;
      return ["horizontal", "vertical"].includes(val);
    }
  },
  items: {
    type: Array
  },
  labelStyle: {
    type: Object
  },
  layout: {
    type: String,
    "default": "horizontal",
    validator: function validator(val) {
      if (!val) return true;
      return ["horizontal", "vertical"].includes(val);
    }
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  title: {
    type: [String, Function]
  }
};

export { props as default };
//# sourceMappingURL=props.mjs.map
